import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { URL_MAP } from '../../shared/urlMap';
import { environment as ENV } from '../../../environments/environment';
import {
  AdicionaAnexoConsultaResponse,
  CatalogoAnexoConsultaDTO,
} from '../../models/adiciona-anexo/adiciona-anexo-consulta.model';

/**
 * Body de `POST /adiciona-anexo/consulta`.
 * Puede enviarse solo `grupoPrograma` o los tres campos del contrato origen.
 */
export interface AdicionaAnexoConsultaRequestPayload {
  grupoPrograma: string;
  tipoPlan?: string;
  lineaNegocio?: string;
}

@Injectable({
  providedIn: 'root',
})
export class AdicionaAnexoConsultaService {
  private apiUrl = `${ENV.HOST}${URL_MAP.API.ADICIONA_ANEXO_CONSULTA}`;

  constructor(private http: HttpClient) {}

  consulta(
    payload: AdicionaAnexoConsultaRequestPayload,
  ): Observable<AdicionaAnexoConsultaResponse> {
    return this.http.post<any>(this.apiUrl, payload).pipe(
      map((raw) => this.normalizarRespuesta(raw)),
    );
  }

  private normalizarRespuesta(raw: any): AdicionaAnexoConsultaResponse {
    const r = raw?.data ?? raw?.resultado ?? raw?.response ?? raw?.Data ?? raw;
    const anexosRaw = r?.anexos ?? r?.Anexos ?? r?.catalogoAnexos ?? r?.CatalogoAnexos ?? [];
    const filas = r?.filas ?? r?.Filas ?? [];
    const mensajeAdvertencia =
      r?.mensajeAdvertencia ?? r?.MensajeAdvertencia ?? null;

    const anexos: CatalogoAnexoConsultaDTO[] = (Array.isArray(anexosRaw)
      ? anexosRaw
      : []
    ).map((item: any) => ({
      idPAnexos: Number(item?.idPAnexos ?? item?.IdPAnexos ?? 0),
      codigo: String(item?.codigo ?? item?.Codigo ?? '').trim(),
      nombre: String(item?.nombre ?? item?.Nombre ?? '').trim(),
      requiereAuditoria: !!(item?.requiereAuditoria ?? item?.RequiereAuditoria),
    }));

    return {
      anexos,
      catalogoAnexos: anexos,
      filas: Array.isArray(filas) ? filas : [],
      mensajeAdvertencia:
        mensajeAdvertencia != null ? String(mensajeAdvertencia) : null,
    };
  }
}
